import { useEffect } from "react";

import { AiAvailability, useAiUnavailableText } from "@/common/hooks/useAiUnavailableText";

export const useAssistantUnavailableText = (
  { data, refetch }: { data?: AiAvailability; refetch: () => Promise<unknown> },
  wasRefused: boolean
): string | null => {
  useEffect(() => {
    if (wasRefused) {
      void refetch();
    }
  }, [wasRefused, refetch]);
  useEffect(() => {
    if (!data?.availableAt || data.isAvailable) {
      return undefined;
    }
    const timer = setTimeout(
      () => void refetch(),
      Math.max(new Date(data.availableAt).getTime() - Date.now(), 0) + 1_000
    );
    return () => clearTimeout(timer);
  }, [data, refetch]);
  return useAiUnavailableText(data);
};
